// extracted by mini-css-extract-plugin
export default {"input":"Input_input__xt37y","small":"Input_small__bAPpr","medium":"Input_medium__Seuj0","large":"Input_large__9ipP3","fullWidth":"Input_fullWidth__L5rnf"};